module.exports = __webpack_public_path__ + "img/edf-bazacle.34cf4a0d.jpg";